<template>
    <v-dialog v-model="dialog" persistent max-width="600" overlay-color="grey darken-1" overlay-opacity=".5" @click:outside="isTranslating ? null : closeTextCardTranslation(false)">
        <v-card v-if="!isTranslating" class="rounded-xl">
            <v-card-title style="word-break: normal" class="justify-center align-center">
                <!-- <span v-if="page==='audioElement'" class="font-weight-bold text-h5 text-center">Translate Subtitles</span> -->
                <span class="font-weight-bold text-h5 text-center">Translate Text Cards for: </span>
            </v-card-title>
            <v-card-subtitle style="word-break: normal" class="justify-center align-center">
                <p class="font-weight-bold text-h6 text-center mt-2">{{ textPost?.title }}</p>
            </v-card-subtitle>

            <v-row justify="center" class="mx-0">
                <v-col cols="12" xl="10" lg="10" md="10" sm="12">
                    <v-autocomplete
                        v-model="selectedTranslationLanguage"
                        label="Select a language (required)"
                        :items="textAddedLanguageCodes"
                        item-text="text"
                        item-value="value"
                        return-object
                        outlined
                        persistent-hint
                        hint="Select the language you will be translating the subtitles into"
                        :disabled="false"
                    ></v-autocomplete>

                </v-col>
            </v-row>

            <v-card-actions>
                <v-row justify="end" no-gutters class="ma-0 pt-3">
                    <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="closeTextCardTranslation(false)">Cancel</v-btn>
                    <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="saveTextAddedTranslation" :disabled="selectedTranslationLanguage === null">Save</v-btn>
                </v-row>
            </v-card-actions>

        </v-card>
        <v-card v-else class="rounded-xl">
            <v-card-title style="word-break: normal" class="justify-center align-center">
                <span v-if="successText === ''" class="mb-2 font-weight-bold text-h5 text-center">Hold tight while we translate your subtitles</span>
                <span v-else class="mb-2 font-weight-bold text-h5 text-center">{{successText}}</span>
            </v-card-title>

            <v-row justify="center" no-gutters>
                <v-col align="center">
                    <v-progress-circular v-if="successText === ''" indeterminate color="primary" :size="100"></v-progress-circular>
                    <v-icon v-else-if="successText === 'Text was translated successfully!'" color="primary" size="100">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" size="100">mdi-close-circle</v-icon>
                </v-col>
            </v-row>

            <v-card-actions>
                <v-row justify="end" no-gutters class="ma-0 pt-3">
                    <!-- <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="closeTextCardTranslation">Close</v-btn> -->
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// import firebase from "../../firebaseConfig.js";
import { getFunctions, httpsCallable } from "firebase/functions";
export default {
    name: "TextCardTranslation",
    props: ["dialog", "page", "textPost", ""],
    data: function() {
        return {
            isTranslating: false,
            selectedTranslationLanguage: null,
            successText: "",
        };
    },
    methods: {
        closeTextCardTranslation: function(wasTranslated) {
            this.$emit("close-text-card-translation", wasTranslated);
        },
        saveTextAddedTranslation: async function() {
            let wasSuccessfullyTranslated = true;
            try {
                this.isTranslating = true;

                const functions = getFunctions();
                const translateTextAdded = httpsCallable(functions, "translateTextAdded");
                /* const res = */await translateTextAdded({
                    postId: this.textPost.postId,
                    postType: this.textPost.postType,
                    targetLanguageCode: this.selectedTranslationLanguage.value, // "ar",
                    targetLanguageName: this.selectedTranslationLanguage.text, // "العربية (عُمان) | Arabic (Oman)",
                });
                this.successText = "Text was translated successfully!";
            } catch (error) {
                console.error(error);
                // this.$store.commit("alertUser", { show: true, text: "Failed to translate subtitle.", type: "snackbar" });
                this.successText = `Failed to translate text. ${error.message || error}`;
                wasSuccessfullyTranslated = false;
            } finally {
                setTimeout(() => {
                    this.isTranslating = false;
                    this.closeTextCardTranslation(wasSuccessfullyTranslated); // Optionally refresh the segment from Firestore or rely on snapshot listener
                }, 2500);
            }
        },
    },
    computed: {
        textAddedLanguageCodes () {
            const languages = [];
            const seenBaseCodes = new Set();
            const excludePrefixes = new Set();

            const codes = this.$languageCodes || [];

            // ----------------------------
            // Build excludePrefixes
            // ----------------------------

            const audioLanguageCode = this.textPost?.textAddedLanguage?.value || '';

            if (audioLanguageCode) {
                excludePrefixes.add(
                    audioLanguageCode,//.split("-")[0].toLowerCase()
                );
            }

            const textAddedByLanguage = this.textPost?.textAddedByLanguage || null;

            if (textAddedByLanguage && typeof textAddedByLanguage === "object") {
                Object.keys(textAddedByLanguage).forEach(code => {
                    if (!code) return;
                    const prefix = code.split("-")[0].trim().toLowerCase();
                    if (prefix) excludePrefixes.add(prefix);
                });
            }

            // ----------------------------
            // Build filtered + deduped list
            // ----------------------------

            codes.forEach(lang => {
                if (!lang || !lang.value || lang.value === "null") return;

                const baseCode = lang.value.split("-")[0].toLowerCase();
                if (!baseCode) return;

                // Skip excluded languages
                if (excludePrefixes.has(baseCode)) return;

                // Skip duplicates (multiple regional variants)
                if (seenBaseCodes.has(baseCode)) return;

                const rawText = lang.text;
                if (!rawText || typeof rawText !== "string") return;

                // Remove parentheses
                const noParens = rawText.replace(/\([^)]*\)/g, "").trim();

                // Split bilingual names
                const parts = noParens
                    .split("|")
                    .map(p => p.trim())
                    .filter(Boolean);

                const displayText =
                    parts.length === 2
                        ? `${parts[0]} | ${parts[1]}`
                        : parts[0];

                languages.push({
                    text: displayText,
                    value: baseCode
                });

                seenBaseCodes.add(baseCode);
            });

            return languages;
        },
    },
    // mounted: function() {},
}
</script>
